﻿import React, { useState, useEffect } from 'react';
import { LookupItem } from '../models/lookup-item';
import { DmaMeasurement } from '../models/dma-measurement';
import DataTemplates from '../templates/data-templates';
import { CrudFunctions } from '../utilities/crud-functions';
import { ResponseError } from '../models/response-error';
import { FieldUpdate } from '../models/field-update';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import SelectBox from 'devextreme-react/select-box';
import NumberBox from 'devextreme-react/number-box';

export interface Props {
    benchSheetId?: string;
}

export default function MinimumSampleSizeComponent(props: Props) {
    const [minimumSampleSize, setMinimumSampleSize] =
        useState<number>();

    const [minimumSampleSizeUom, setMinimumSampleSizeUom] =
        useState<number>();
        
    const [samplePreparationMeasurementUoms, setSamplePreparationMeasurementUoms] =
        useState<LookupItem[]>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [dataLoaded, setDataLoaded] =
      useState<boolean>(false);

    useEffect(() => {
        if(!dataLoaded)
            getAllData();
    }, []);

    return (
        <div id="minimumSampleSizePanel">
            <div className="lq-header pw-margin-top-05 pw-bg-green">
                <div className="lq-header-title">Minimum Sample Size</div>
            </div>

            <div className="pw-form-section">
                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">Size</div>
                        <NumberBox id="minimumSampleSize" hint='NA'
                            value={minimumSampleSize ?
                                minimumSampleSize : undefined}
                            onValueChanged={minimumSampleSizeValueChanged} />
                    </div>

                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">UOM</div>
                        <SelectBox id="minimumSampleSizeUom"
                            placeholder='NA'
                            itemRender={DataTemplates.ProductFormItemRender}
                            displayExpr={'name'} valueExpr={'id'}
                            dataSource={samplePreparationMeasurementUoms ?
                                samplePreparationMeasurementUoms : []}
                            onValueChanged={minimumSampleSizeUomValueChanged}
                            value={minimumSampleSizeUom ?
                                minimumSampleSizeUom : undefined} />
                    </div>
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function minimumSampleSizeValueChanged(e: any) {

        if (!dataLoaded)
            return;


        console.log("minimumSampleSizeValueChanged");
        console.log(e);

        setMinimumSampleSize(e.value);

        if (e.element && e.value) {
            const caller = e.element.id;

            updateField(caller, e.value);
        }
    }

    function minimumSampleSizeUomValueChanged(e: any) {
        if (!dataLoaded)
            return;

        console.log("minimumSampleSizeUomValueChanged");
        console.log(e);
                
        setMinimumSampleSizeUom(e.value);

        if (e.element && e.value) {
            const caller = e.element.id;

            updateField(caller, e.value);
        }
    }

    async function updateField(caller: string, val: any) {

        if (!dataLoaded)
            return;

        const fieldUpdate: FieldUpdate = {
            rowId: props.benchSheetId,
            field: caller,
            value: val
        };

        await updateMinimumSampleSizeField(fieldUpdate)
            .then(data => {
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Updating Minimum Sample Size");
            });
    }

    // get functions

    async function getMinimumSampleSize() {
        await CrudFunctions.getData(`benchsheets/minimumsamplesize/${props.benchSheetId}`)
            .then(data => {
                const returnedSampleSize = data as DmaMeasurement;

                if (returnedSampleSize) {
                    setMinimumSampleSize(returnedSampleSize.value);
                    setMinimumSampleSizeUom(returnedSampleSize.uom);
                }
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Minimum Sample Size");
            });
    }

    async function getSamplePreparationMeasurementUoms() {
        await CrudFunctions.getData("benchsheets/samplepreparationmeasurementuoms")
            .then((data) => {
                setSamplePreparationMeasurementUoms(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving UOMs");
            });
    }

    async function updateMinimumSampleSizeField(fieldUpdate: FieldUpdate) {
        return await CrudFunctions.putData("benchSheets/minimumsamplesizefield", fieldUpdate);
    }

    async function getAllData() {
        await Promise.all([
            await getMinimumSampleSize(),
            await getSamplePreparationMeasurementUoms()
        ])
            .then(() => {
                setDataLoaded(true);
            })        
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}